module.exports = __webpack_public_path__ + "static/media/feature4.752b7041.jpeg";